// method to validate custom attributes with prefix "data-" as per w3c standard
export const CustomAttributeParser = (customAttributes) => {
    const attribsWithPrefixData = new Object();
    customAttributes
        ? Object.keys(customAttributes).map((key) => {
            key.startsWith('data-')
                ? (attribsWithPrefixData[key] = customAttributes[key])
                : console.error(new Error(`Cannot render the custom attribute "${key}" as it do not have prefix "data-"`));
        })
        : '';
    return attribsWithPrefixData;
};
//# sourceMappingURL=CustomAttributeParser.js.map